import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Icon, Tooltip } from "./..";
import styles from './IconTooltip.scss';

var TooltipIcon = function TooltipIcon(_ref) {
  var iconName = _ref.iconName,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'icon' : _ref$iconColor,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["iconName", "iconColor", "children"]);

  return /*#__PURE__*/React.createElement(Tooltip, Object.assign({}, otherProps, {
    controlElement: /*#__PURE__*/React.createElement(Icon, {
      className: styles.TooltipIcon_iconWrapper_icon,
      name: iconName,
      color: iconColor
    }),
    controlElementContainerClassName: styles.TooltipIcon_iconWrapper
  }), children);
};

export default TooltipIcon;